/* eslint-disable camelcase */
import { Amplify } from "aws-amplify";
import { fetchAuthSession } from "aws-amplify/auth";
import aws4 from "aws4-tiny";
import { AWSAmplifyConfig } from "../config/aws-amplify-config";
export async function getAuthorizationHeaders({ method, url, payload, }) {
    var _a, _b;
    const amplifyConfig = Amplify.getConfig();
    if (!amplifyConfig.Auth) {
        Amplify.configure({
            Auth: {
                Cognito: AWSAmplifyConfig,
            },
        });
    }
    const data = payload ? JSON.stringify(payload) : "";
    const { credentials } = await fetchAuthSession({ forceRefresh: true });
    if (!credentials) {
        return {};
    }
    const { accessKeyId, secretAccessKey, sessionToken } = credentials;
    const urlObject = new URL(url);
    const request = {
        host: urlObject.host,
        method,
        path: `${urlObject.pathname}${urlObject.search}`,
        url,
        body: data,
        headers: {
            "content-type": "application/json",
        },
    };
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const signedRequest = aws4.sign(request, {
        accessKeyId,
        secretAccessKey,
        sessionToken,
    });
    (_a = signedRequest.headers) === null || _a === void 0 ? true : delete _a["Host"];
    (_b = signedRequest.headers) === null || _b === void 0 ? true : delete _b["Content-Length"];
    return signedRequest.headers || {};
}
